export default {"src":"/planos/_next/static/media/equifax-hand-check.204fc2b9.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};